import * as THREE from 'three';

export const getHorizontalRotationBetweenPoints = (point1, point2) => {
  const vOX = new THREE.Vector3(0, 0, 1); // OX axis

  const direction = new THREE.Vector3();
  direction.subVectors(point1, point2);
  direction.y = 0;
  direction.normalize();
  vOX.normalize();

  const dot = direction.dot(vOX);
  const cross = new THREE.Vector3().crossVectors(vOX, direction).y;

  let horizontalRotation = Math.acos(dot);

  if (cross < 0) {
    horizontalRotation = -horizontalRotation;
  }

  return THREE.MathUtils.radToDeg(horizontalRotation);
};

export const getVerticalRotationBetweenPoints = (point1, point2) => {
  const p1 = point1.clone();
  const p2 = point2.clone();
  p1.y = 0;
  p2.y = 0;

  const deltaXZ = p1.distanceTo(p2);
  const deltaY = point2.y - point1.y;
  const angleRadians = Math.atan2(deltaY, deltaXZ);
  return THREE.MathUtils.radToDeg(angleRadians);
};

export const getRotationBetweenPoints = (point1, point2) => {
  const point1Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point1.x, point1.y, point1.z);
  const point2Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point2.x, point2.y, point2.z);
  const pitchDegrees = getVerticalRotationBetweenPoints(point1Vec3, point2Vec3);
  const yawDegrees = getHorizontalRotationBetweenPoints(point1Vec3, point2Vec3);
  return { pitchDegrees, yawDegrees };
};

export const getHorizontalAngleBetweenPoints = (point1, point2, point3) => {
  const p1 = new THREE.Vector3(point1.x, 0, point1.z);
  const p2 = new THREE.Vector3(point2.x, 0, point2.z);
  const p3 = new THREE.Vector3(point3.x, 0, point3.z);

  const vector21 = new THREE.Vector3().subVectors(p1, p2).normalize();
  const vector23 = new THREE.Vector3().subVectors(p3, p2).normalize();

  const angle = vector21.angleTo(vector23);
  const cross = new THREE.Vector3().crossVectors(vector21, vector23).y;

  const isLeftTurn = cross < 0;

  return { angle, isLeftTurn };
};
